export const INJECTED_COLOR_MODE = 'INJECTED_COLOR_MODE';

export const QUERY_PARAM_LOGGEDIN = 'loggedIn';
export const QUERY_PARAM_LOGGOUT = 'loggedOut';
export const QUERY_PARAM_SIGNUP = 'signUp';

export const BASLER_EXPRESS_DELIVERY_CARRIER_CODE = 'basler_tablerate';
export const BASLER_STANDARD_DELIVERY_CARRIER_CODE = 'tablerate';
export const BASLER_PICKUP_CARRIER_CODE = 'pickupdelivery';

export const G4_EVENT_NAME_ADD_TO_CART = 'add_to_cart';
export const G4_EVENT_NAME_ADD_TO_REQUESTCART = 'request_quote';
export const G4_EVENT_NAME_VIEW_CART = 'view_cart';
export const G4_EVENT_NAME_VIEW_REQUEST_CART = 'view_request_cart';
export const G4_EVENT_NAME_REMOVE_FROM_CART = 'remove_from_cart';
export const G4_EVENT_NAME_UPDATE_CART = 'update_cart';
export const G4_EVENT_NAME_BEGIN_CHECKOUT = 'begin_checkout';
export const G4_EVENT_NAME_CHECKOUT_ENTERED = 'enter_checkout';
export const G4_EVENT_NAME_ADD_SHIPPING_INFO = 'add_shipping_info';
export const G4_EVENT_NAME_ADD_PAYMENT_INFO = 'add_payment_info';
export const G4_EVENT_NAME_PURCHASE = 'purchase';
export const G4_EVENT_NAME_LOGIN = 'login';
export const G4_EVENT_NAME_LOGOUT = 'logout';
export const G4_EVENT_NAME_SIGN_UP = 'sign_up';
export const G4_METHOD_NAME_BASLER_ID = 'Basler ID';
